export const GENERIC_ERROR_MESSAGE =
  "There was an error on our server. Please try again.";
